import { MatchParams as ClassMatchParams } from '@/legacy/Class/types';
import { FileIdentifier } from '@/legacy/store/slices/entities/Codebases/types';
import { ViewIdentifier } from '@/legacy/store/slices/entities/Views/types';
import { WorkflowIdentifier } from '@/legacy/store/slices/entities/Workflows/types';
import { WorkletIdentifier } from '@/legacy/store/slices/entities/Worklets/types';
import { MatchParams as ChainMatchParams } from '@/pages/Chain/types';
import { MatchParams as DeployModelMatchParams } from '@/pages/DeployModel/types';
import { MatchParams as ModelMatchParams } from '@/pages/Model/types';
import { MatchParams as OrgSettingsMatchParams } from '@/pages/OrgSettings/types';
import { MatchParams as PlaygroundMatchParams } from '@/pages/Playground/types';
import { MatchParams as SettingsMatchParams } from '@/pages/Settings/types';
import { MatchParams as SharedEndpointMatchParams } from '@/pages/SharedEndpoint/types';
import { MatchParams as TeamSettingsMatchParams } from '@/pages/TeamSettings/types';
import { MatchParams as TrainingProjectMatchParams } from '@/pages/Training/types';
import { MatchParams as TrainingJobMatchParams } from '@/pages/Training_Legacy/types';
import { MatchParams as WorkspaceMatchParams } from '@/pages/Workspace/types';
import { MatchParams as WorkspaceTeamsMatchParams } from '@/pages/WorkspaceTeams/types';

import { BasetenPageEnum } from '../types';

export type PageParams = {
  [BasetenPageEnum.Application]: WorkflowIdentifier;
  [BasetenPageEnum.View]: ViewIdentifier;
  [BasetenPageEnum.ViewOperator]: ViewIdentifier;
  [BasetenPageEnum.Worklet]: WorkletIdentifier & WorkflowIdentifier & { nodeId?: string };
  [BasetenPageEnum.Code]: FileIdentifier;
  [BasetenPageEnum.Class]: ClassMatchParams;
  [BasetenPageEnum.Model]: ModelMatchParams;
  [BasetenPageEnum.Chain]: ChainMatchParams;
  [BasetenPageEnum.SharedEndpoint]: SharedEndpointMatchParams;
  [BasetenPageEnum.TrainingJob]: TrainingJobMatchParams;
  [BasetenPageEnum.Settings]: SettingsMatchParams | OrgSettingsMatchParams;
  [BasetenPageEnum.Workspace]: WorkspaceMatchParams;
  [BasetenPageEnum.DeployModel]: DeployModelMatchParams;
  [BasetenPageEnum.WorkspaceTeams]: WorkspaceTeamsMatchParams;
  [BasetenPageEnum.Playground]: PlaygroundMatchParams;
  [BasetenPageEnum.TrainingProject]: TrainingProjectMatchParams;
  [BasetenPageEnum.TeamSettings]: TeamSettingsMatchParams;
};

export type ParamsForPage<TPage extends BasetenPageEnum> = TPage extends keyof PageParams
  ? PageParams[TPage]
  : undefined;

export enum PageSwitchingMethod {
  Push = 'push',
  Open = 'open',
  Replace = 'replace',
  Refresh = 'refresh',
}

export type PageSwitcher = {
  // Pages that require params
  <TPage extends keyof PageParams>(
    page: TPage,
    pathParams: ParamsForPage<TPage>,
    queryParams?: Record<string, string>,
    method?: PageSwitchingMethod,
  ): void;
  // Pages for which params are empty/optional
  <TPage extends Exclude<BasetenPageEnum, keyof PageParams>>(
    page: TPage,
    pathParams?: undefined,
    queryParams?: Record<string, string>,
    method?: PageSwitchingMethod,
  ): void;
};
